export default {
  title: 'Provider profile',
  editButton: 'Edit',
  requiredInformation: {
    title: 'Data required',
    answerTextLabel: 'Write your answer...',
    status: {
      rejected: 'Rejected',
      pending: 'Pending',
      answered: 'Answered'
    }
  },
  editProfile: {
    personalInformation: {
      title: 'Personal information',
      givenNames: 'Given names',
      surnames: 'Surnames',
      datePlaceholder: 'dd/mm/yyyy',
      dateOfBirth: 'Date of birth',
      rfc: 'RFC',
      curp: 'CURP',
      email: 'Email',
      cost: 'Query cost',
      responsibilityPolicies: 'Current Professional Responsibility Policies',
      rcPolicy: 'RC policy expiration date'
    },
    profileImage: {
      title: 'Profile image',
      changeImage: 'Change image'
    },
    personalHomeInformation: {
      title: 'Home',
      street: 'Street',
      cologne: 'Cologne',
      city: 'City',
      state: 'State',
      postalCode: 'Postal code',
      country: 'Country'
    },
    taxInformation: {
      title: 'Tax residence',
      street: 'Street',
      cologne: 'Cologne',
      city: 'City',
      state: 'State',
      postalCode: 'Postal code',
      country: 'Country'
    },
    bankInformation: {
      title: 'Bank information',
      name: 'Name',
      clabe: 'Clabe'
    },
    officeInformation: {
      title: 'Office',
      arrayTitle: 'Office {index}',
      street: 'Street',
      cologne: 'Cologne',
      city: 'City',
      state: 'State',
      postalCode: 'Postal code',
      country: 'Country',
      fax: 'Fax',
      phoneOffice: 'Phone office',
      startTime: 'Start time',
      endTime: 'End time'
    },
    officeHospitalInformation: {
      title: 'Office hospital',
      arrayTitle: 'Hospital {index}',
      street: 'Street',
      cologne: 'Cologne',
      city: 'City',
      state: 'State',
      postalCode: 'Postal code',
      country: 'Country',
      fax: 'Fax',
      phoneOffice: 'Phone office',
    },
    academic: {
      title: 'Academic',
      arrayTitle: 'Title {index}',
      titleName: 'Title name',
      professionalLicense: 'Professional license',
      specialtyArrayTitle: 'Specialty {index}',
      specialty: 'Specialty / subspecialty',
      specialtyId: 'Specialty ID'
    },
    steps: {
      providerInformationLabel: 'Physician Information',
      specializationLabel: 'Specialization and place of care',
      cancelButton: 'Cancel',
      continueButton: 'Continue'
    }
  },
  guest: {
    title: 'Enter the following information',
    retryLabel: 'You can resubmit the request at {time} segs',
    sendOtpButton: 'Send',
    emailHint: 'Enter the email with which you registered, to receive the consultation code',
    validOtpButton: 'Consult',
    validationOtpFail: 'The code is not valid'
  },
  doctorInformation: {
    dateOfBirth: 'Date of birth',
     rfc: 'RFC',
     curp: 'CURP',
     email: 'Email',
     medicalCircle: 'Medical Circle',
     cost: 'Query cost',
     subnet: 'Subnet',
     responsibilityPolicies: 'Current Professional Responsibility Policies',
     rcPolicy: 'RC policy expiration date'
  },
  home: {
    title: 'Home',
    street: 'Street',
    cologne: 'Cologne',
    city: 'City',
    state: 'State',
    postalCode: 'Postal code',
    country: 'Country'
  },
  taxResidence: {
    title: 'Tax residence',
    street: 'Street',
    cologne: 'Cologne',
    city: 'City',
    state: 'State',
    postalCode: 'Postal code',
    country: 'Country'
  },
  office: {
    title: 'Offices',
    arrayTitle: 'Office {index}',
    street: 'Street',
    cologne: 'Cologne',
    city: 'City',
    state: 'State',
    postalCode: 'Postal code',
    country: 'Country',
    fax: 'Fax',
    phoneOffice: 'Phone office',
    startTime: 'Start time',
    endTime: 'End time'
  },
  officeHospital: {
    title: 'Office hospital',
    arrayTitle: 'Hospital {index}',
    street: 'Street',
    cologne: 'Cologne',
    city: 'City',
    state: 'State',
    postalCode: 'Postal code',
    country: 'Country',
    fax: 'Fax',
    phoneOffice: 'Phone office',
  },
  bank: {
    title: 'Bank information',
    arrayTitle: 'Bank {index}',
    bank: 'Bank',
    clabe: 'Clabe'
  },
  academic: {
    title: 'Academic',
    arrayTitle: 'Title {index}',
    titleName: 'Title name',
    professionalLicense: 'Professional license',
    specialtyArrayTitle: 'Specialty {index}',
    specialty: 'Specialty / subspecialty',
    specialtyId: 'Specialty ID'
  },
  assistant: {
    title: 'Assistants',
    arrayTitle: 'Assistant {index}',
    givenNames: 'Names',
    surnames: 'Surnames',
    dateOfBirth: 'Date of birth',
    rfc: 'RFC',
    email: 'Email'
  },
  status: {
    rejected: {
      title: 'Unapproved Profile',
      message: 'Some of the data entered is incorrect or does not have support for validation. Please update the information or contact the insurer.'
    },
    approved: {
      title: 'Verified profile',
      message: 'All data has been corroborated by an insurance agent. Remember that if you want to edit them, they will be pending approval.'
    },
    inProgress: {
      title: 'Information pending approval',
      message: 'Within 48 hours, the information will be reviewed to verify that it is correct. We will communicate by email to {email}'
    },
    dataRequired: {
      title: 'Required data',
      message: 'Additional information is needed, see the section "Required data" for more details.'
    }
  }
}